import { ApiService }                from '../../app-lite/api/api.service';
import { SessionService }            from '../../app-lite/sessions/session.service';
import { UserNotificationTypeModel } from '../../app-lite/users/models/user.notification-type';

import MobileUserHtml   from './user.mobile.html';
import UserHtml         from '../../app-lite/users/user.html';
import UserSettingsHtml from './user.settings.html';
import UsersHtml        from './users.html';

export function UsersStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'setLoaded',
    name       : 'app.users',
    templateUrl: UsersHtml,
    url        : '/users'
  })
  .state({
    controller: 'UserCtrl',
    name      : 'app.user',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: UserHtml,
    url        : '/user/:id',
    resolve    : {
      session  : ( sessionObjAPI : SessionService ) : Promise<any> => sessionObjAPI.refresh(),
      user     : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : Promise<any> | object => $stateParams.id
        ? workshopAPI.get('/user', $stateParams.id)
        : {},
      userQuote: ( workshopAPI : ApiService ) : Promise<any> => workshopAPI.get('/users/quote_for_user')
    }
  })
  .state({
    controller : 'UserSettingsCtrl',
    name       : 'app.user-settings',
    templateUrl: UserSettingsHtml,
    url        : '/user_settings?code&xero_request_successful&google_link_success&google_link_error',
    resolve    : {
      user: ( sessionObjAPI : SessionService, workshopAPI : ApiService ) => workshopAPI.get('/user', sessionObjAPI.base().user_id)
    }
  })
  .state({
    controller: 'MobileUserCtrl',
    name      : 'app.mobile-user',
    params    : {
      id         : { squash: true, value: null },
      mechanic_id: { squash: true, value: null }
    },
    templateUrl: MobileUserHtml,
    url        : '/:mechanic_id/mobile_user/:id',
    resolve    : {
      company : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      mechanic: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | object =>
        $stateParams.mechanic_id
          ? workshopAPI.get('/mechanic', $stateParams.mechanic_id)
          : {},
      notificationTypes: ( $q : ng.IQService, $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<Array<UserNotificationTypeModel>> =>
        $stateParams.id
          ? workshopAPI.get('/user_mobile_notification_types',$stateParams.id)
          : $q.when([]),
      user: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | object =>
        $stateParams.id
          ? workshopAPI.get('/user', $stateParams.id)
          : {}
    }
  });
}